import React from 'react'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'

export const SolutionsSection = () => {
  return (
    <SolutionsSectionStyles id='soluciones'>
      <StyledSlatInner className='solutions__inner'>
        <h2>Nuestros Servicios</h2>
        <div className='solutions__services'>
          <div className='solutions__item'>
            <div className='solutions__item__icon solutions__item__icon--tech-support'/>
            <div>
              <h3>SOPORTE TÉCNICO</h3>
              <ul>
                <li>Soporte en Sitio</li>
                <li>Soporte Remoto</li>
                <li>Outsourcing</li>
                <li>Mantenimiento</li>
                <li>Servicio 24/7</li>
              </ul>
            </div>
          </div>
          <div className='solutions__item'>
            <div className='solutions__item__icon solutions__item__icon--communications'/>
            <div>
              <h3>COMUNICACIONES</h3>
              <ul>
                <li>Voz y Datos</li>
                <li>Fibra Óptica</li>
                <li>Videoconferencias</li>
                <li>Videovigilancia</li>
                <li>Switch y Routers</li>
              </ul>
            </div>
          </div>
          <div className='solutions__item'>
            <div className='solutions__item__icon solutions__item__icon--licensing'/>
            <div>
              <h3>LICENCIAMIENTO</h3>
              <ul>
                <li>Antivirus</li>
                <li>G Suite</li>
                <li>Microsoft</li>
                <li>Servicios Cloud</li>
                <li>Servidores</li>
              </ul>
            </div>
          </div>
        </div>
      </StyledSlatInner>
    </SolutionsSectionStyles>
  )
}

const SolutionsSectionStyles = StyledSlatOuter.extend`
  .solutions {
    &__inner {
      font-size: 16px;
      text-align: left;
      @media (min-width: ${({ theme }) => theme.medium.start}) {
        font-size: 20px;
      }

      h2 {
        text-transform: uppercase;
        font-size: 25px;
        margin-bottom: 20px;
        @media (min-width: ${({ theme }) => theme.medium.start}) {
          margin-bottom: 30px;
          font-size: 35px;
        }
      }
    }

    &__services {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      @media (min-width: ${({ theme }) => theme.medium.start}) {
        flex-flow: row;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }

    &__item {
      width: 100%;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: flex-start;
      @media (min-width: ${({ theme }) => theme.medium.start}) {
        width: 30%;
        flex-wrap: wrap;
        flex-flow: column;
      }
      @media (min-width: ${({ theme }) => theme.large.start}) {
        width: 20%;
      }

      &__icon {
        width: 100px;
        height: 100px;
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 50px;
        @media (min-width: ${({ theme }) => theme.large.start}) {
          width: 150px;
          height: 150px;
          margin-right: 0;
        }

        &--tech-support {
          background-image: url(/svg/icon--tech-support--blue.svg);
        }
        &--communications {
          background-image: url(/svg/icon--computer--blue.svg);
        }
        &--licensing {
          background-image: url(/svg/icon--license--blue.svg);
        }
      }

      h3 {
        color: ${({ theme }) => theme.lightBlue};
        margin: 0;
        @media (min-width: ${({ theme }) => theme.medium.start}) {
          margin: auto;
        }

      }

      ul {
        padding-left: 10px;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/SolutionsSection.js